export default __webpack_public_path__ + "static/media/right-green.2e57a26f.svg";